import React from "react";

interface Props {
  children?: React.ReactNode;
  column?: boolean;
  justifyContentSpaceBetween?: boolean;
  justifyContentCenter?: boolean;
  justifyContentEnd?: boolean;
  alignItemsCenter?: boolean;
  grow?: boolean;
  noShrink?: boolean;
}

export const Flex = ({
  column,
  justifyContentSpaceBetween,
  justifyContentCenter,
  justifyContentEnd,
  alignItemsCenter,
  grow,
  noShrink,
  children
}: Props) => {
  var justifyContent;
  switch (true) {
    case justifyContentSpaceBetween:
      justifyContent = "space-between";
      break;

    case justifyContentCenter:
      justifyContent = "center";
      break;

    case justifyContentEnd:
      justifyContent = "flex-end";
      break;

    default:
      break;
  }
  return (
    <div
      style={{
        display: "flex",
        flexDirection: (column && "column") || undefined,
        justifyContent,
        alignItems: (alignItemsCenter && "center") || undefined,
        flexGrow: (grow && 1) || undefined,
        flexShrink: (noShrink && 0) || undefined
      }}
      {...{ children }}
    />
  );
};
